import Release from './release';

function domainName() {
   //return "http://localhost:3000/"+Release();
    return "https://vdms.strackit.com/"+Release();
}
  
  export default domainName;
  